import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import classNames from 'classnames';
import './DashboardGlobal.scss';
import {DragDropContext, Droppable, Draggable} from '@hello-pangea/dnd';
import {Translate, I18n} from 'react-redux-i18n';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css';
import {makeUniqueAbbreviation} from './Helpers.js';

import style from './Dashboard.module.css';
import marker from '../../assets/img/maps-marker.png';


import {
  move as moveAction,
  stateChange as stateChangeAction
} from './UnitViewActions';

import {
  selectUnits as selectUnitsAction,
  selectLocation as selectLocationAction,
  selectPreviewLocation as selectPreviewLocationAction,
} from './DashboardActions';

const MAP_VIEW_ENABLED = process.env.REACT_APP_MAP_VIEW_ENABLED;

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      multi: [],
      selectedLocationId: false,
      isDragging: false,
      isMultiSelect: false,
      isChatDisabled: false,
      unitsPerRow: this.smartColumnCount(),
      draggableId: '',
      selectedState: '',
      tempUnitMove: {},
      dropTarget: null,
      draggedUser: null,
      selectedUsers: [],
    };
    this.draggedElement = React.createRef();
    
    this.handleChatDisabled = this.handleChatDisabled.bind(this);
  }

  smartColumnCountFrom(start) {
    let locations = this.props.exercise.scenario.locations;
    let prefixFind = locations[start].name.slice(0, 2);

    if (this.props.exercise.scenario.locationsStates) {
      return this.props.exercise.scenario.locationsStates.length;
    }

    if (prefixFind !== '__') {
      let i = 2;
      while (i <= 11 && locations[start + i].name.indexOf(prefixFind) !== 0) i++;


      return i;
    } else {
      return 11;
    }
  }

  smartColumnCount() {
    try {
      for (let j = 0; j < 6; j++) {
        let columnCount = this.smartColumnCountFrom(j);
        if (columnCount < 11) {
          return columnCount;
        }
      }
      return 3;
    } catch (err) {
      return 3;
    }
  }

  onDragStart(res) {
    this.setState({draggableId: res.draggableId});
    this.setState({isDragging: true});
  }

  onDragEnd(res) {
    let dest = res.destination ? res.destination.droppableId : false;
    let from = res.source ? res.source.droppableId : false;

    if (dest) {
      if (from != dest) {
        if (this.props.selectedUnits.length > 0 && this.state.isMultiSelect) {
          this.props.move(this.props.selectedUnits, dest);
          // this.props.selectUnits([]);
        } else if (res.draggableId) {
          this.props.move([res.draggableId], dest);
        }
      }
      this.props.selectPreviewLocation(dest);
      this.props.selectLocation(dest);
    }
    this.setState({isDragging: false});

  }

  toggleToMultiSelect(userId, isAdding) {
    let newMulti = this.props.selectedUnits.slice();
    let index = newMulti.indexOf(userId);
    if (index >= 0 && !isAdding) {
      newMulti.splice(index, 1);
    } else if (index == -1) {
      newMulti.push(userId);
    }

    this.props.selectUnits(newMulti);
  }

  toggleSelectAll() {
    const participants = [];
    this.props.exercise.scenario.locations.forEach((location) => {
      location?.users.forEach((user) => {
        participants.push(user);
      });
    });
    console.log("Participants IDs", participants);
    if(this.state.selectedUsers.length < participants.length) {
      console.log("selected user less");
      this.setState({isMultiSelect: true, selectedUsers: participants});
      // this.props.selectUsers(participants.map((p) => p.id))
      this.props.selectUnits(participants.map((p) => p.id))
    } else {
      this.setState({selectedUsers: []});
      this.props.selectUnits([]);
    }
    // if (this.props.selectedUnits.length >= this.props.exercise.users.length - 1) {
    //   this.setState({isMultiSelect: false});
    //   this.props.selectUnits([]);
    // } else {
    //   this.setState({isMultiSelect: true, selectedUsers: participantsIds});
    //   this.props.selectUnits(participantsIds);
    // }
  }

  onUnitClick(e, userId) {
    if (this.state.isMultiSelect) {
      this.toggleToMultiSelect(userId);
    } else {
      this.props.selectUnits([userId]);
    }
  }

  resetMultiLocation() {
    this.props.move(this.props.selectedUnits, 'initial');
  }

  onUnitsPerRowChange(e) {
    this.setState({unitsPerRow: e.target.value});
  }

  unitsStateChange(e) {
    let users = this.props.exercise.users
      .filter(user => user.type !== 'ORGANIZER' && user.status === 'READY')
      .map(u => u.id);
    this.props.stateChange(users, e.target.value);
    this.setState({selectedState: e.target.value});
  }
  
  setShowMapToUser(checked, userId) {
    const { scenario } = this.props.exercise;
    global.socket.emit('user_map_toggle', { 
      userId,
      message: {
        value: checked,
        ...(checked && {
          img: scenario.url.split('/').slice(0, -1).join('/') + '/files/' + scenario.mapInfo.image,
          locations: scenario.mapInfo.locations,
        })
      }
    });
  }
  
  handleChatDisabled() {
    this.setState({'isChatDisabled': !this.state.isChatDisabled}, () => {
      global.socket.emit('disable_chat', {
        message: {
          value: this.state.isChatDisabled,
        }
      })
    })
  }

  render() {

    const {users, scenario, companyId} = this.props.exercise;

    const exercise = this.props.exercise;
    const participants = users.filter(user => user.type !== 'ORGANIZER' && user.status === 'READY');
    participants.forEach((user, i) => user.number = i + 1);
    const locations_by_ids = {};
    const locations = ((scenario && scenario.locations).map((location) => {
      location.users = participants.filter(user => user.location === location.id);
      locations_by_ids[location.id] = location;
      return location;
    }));

    let firstSelectedId = this.props.selectedUnits[0];
    let state = '';
    if (firstSelectedId) {
      let firstSelected = users.find(u => u.id === firstSelectedId);
      let firstSelectedLocation = locations.find(l => l.id === firstSelected?.location);

      state = firstSelectedLocation?.state;
      
      if(state === undefined) {
        console.log("user disconnected")
        this.props.selectUnits([]);
      }
    }
    const show_map = MAP_VIEW_ENABLED && scenario.mapInfo && !!scenario.mapInfo.image;

    let mapLocations;
    if (show_map && scenario.mapInfo.locations) {
      mapLocations = scenario.mapInfo.locations.map(l => {
        let loc = locations.find(loc => (loc.name === l.name && loc.state === exercise.state));
        l.curStateLocID = loc ? loc.id : '';
        l.users = loc ? loc.users || [] : [];
        l.states = scenario.locations.filter((loc) => loc.name === l.name).map((loc) => loc.state);
        return l;
      })
    }
    // console.log({mapLocations})


    return (
      <div>
        <div className="unidash__action-bar">
          <button className="unidash__btn"
                  onClick={this.toggleSelectAll.bind(this)}>{this.state.selectedUsers.length < participants.length ? 'Select all' : 'Deselect all'} </button>

          <input id="multiselectInput" type="checkbox" className="form-check-input" checked={this.state.isMultiSelect}
                 onChange={() => {this.setState({'isMultiSelect': !this.state.isMultiSelect, selectedUsers: []}); this.props.selectUnits([])}}/>

          <label htmlFor="multiselectInput">&nbsp;<Translate value="exerciseRun.Multi"/></label>
          
          <input id="chatDisabled" type="checkbox" className="form-check-input" checked={this.state.isChatDisabled}
                 onChange={this.handleChatDisabled}/>

          <label htmlFor="chatDisabled">&nbsp;<Translate value="exerciseRun.ChatDisabled"/></label>


          {
            scenario.locationsStates && scenario.locationsStates.length > 1 &&
            <span>&nbsp;&nbsp;&nbsp;&nbsp;
              <Translate value="exerciseRun.ChangeState"/>&nbsp;&nbsp;
              <select value={exercise.state} onChange={this.unitsStateChange.bind(this)}>
                {scenario.locationsStates.map(state => <option value={state}
                                                               key={state}>{state} </option>)}
              </select>
            </span>
          }
          
          {!show_map &&
            <div className="unidash__action-bar-last">
              <Translate value="exerciseRun.LocPerRow"/>:&nbsp;
              <select value={this.state.unitsPerRow} onChange={this.onUnitsPerRowChange.bind(this)}>
  
                <option value="3" key="3">3</option>
                <option value="4" key="4">4</option>
                <option value="5" key="5">5</option>
                <option value="6" key="6">6</option>
                <option value="7" key="7">7</option>
                <option value="8" key="8">8</option>
                <option value="9" key="9">9</option>
                <option value="10" key="10">10</option>
                <option value="all" key="all">{I18n.t('controls.all')}</option>
                <option value="scroll" key="scroll">{I18n.t('controls.scroll')}</option>
              </select>
            </div>
          }

        </div>
        {/*!show_map &&
        <div className={'unidash' + ' unidash--' + this.state.unitsPerRow + '-per-row'}>
          <DragDropContext onDragStart={this.onDragStart.bind(this)}
                           onDragEnd={this.onDragEnd.bind(this)}>
            {
              (locations || []).map((location, i) => {
                  let isEmptyLoc = location.name.indexOf('__') === 0;

                  return <div
                    className={classNames({
                      'unidash__view': true,
                      'unidash__view--current-state': location.state === exercise.state,
                      'unidash__view--greyBack': !isEmptyLoc,
                      'unidash__view--selected': this.props.selectedLocation === location.id,
                      'unidash__view--gap': isEmptyLoc,
                    })}
                    key={i}>

                    <div className={'unidash__view-title'}
                         title={isEmptyLoc ? '' : location.name + (location.state ? ` [${location.state}]` : '')}
                         location_id={location.id}
                         onClick={(e) => !isEmptyLoc && this.props.selectLocation(location.id)}>{isEmptyLoc ? '' : location.name + (location.state ? ` [${location.state}]` : '')}</div>
                    <div className={style['unidash__view-container']}>

                      {!isEmptyLoc ?
                        <Droppable droppableId={location.id}>
                          {(provided, snapshot) => (

                            <div ref={provided.innerRef}>
                              {location.users.map((user, i) => {
                                let className = classNames({
                                  [style['unidash__unit']]: true,
                                  [style['unidash__unit--multi']]: this.props.selectedUnits.indexOf(user.id) >= 0,
                                  [style['unidash__unit--multi-dragging']]: this.props.selectedUnits.indexOf(user.id) !== -1 && this.state.isDragging && this.state.draggableId !== user.id
                                });
                                return (
                                  <Draggable key={user.id}
                                             draggableId={user.id} index={i}
                                  >
                                    {(provided, snapshot) => {

                                      const shouldShowSelection = snapshot.isDragging && this.props.selectedUnits.length > 1;

                                      return <div className={className}
                                                  title={user.name}
                                                  onClick={(e) => this.onUnitClick(e, user.id)}
                                                  ref={provided.innerRef}
                                                  {...provided.draggableProps}
                                                  {...provided.dragHandleProps}>

                                        {user.name}
                                        {shouldShowSelection ? <div
                                          className="unidash__dragging-count">{this.props.selectedUnits.length}</div> : null}

                                      </div>;


                                    }}

                                  </Draggable>
                                );
                              })
                              }
                              {provided.placeholder}
                            </div>
                          )}
                        </Droppable>
                        :
                        <div></div>
                      }
                    </div>
                  </div>;
                }
              )
            }
          </DragDropContext>
        </div>
        */}

        {show_map && <div className="mapview">
          <div className="mapview__map">
              <div className="mapview__holder" style={{position: 'relative'}}>
                <img src={
                // scenario.url.split('/').slice(0, -1).join('/') + '/files/' + scenario.mapInfo.image
                  (() => {
                    const image_src = scenario.url.split('/').slice(0, -1).join('/') + '/files/' + scenario.mapInfo.image;
                    let mapImageSrc = image_src.startsWith("data:") || image_src.startsWith("https:")? image_src : ("/api/image/" + companyId + '/' + scenario.url.split('/').slice(0, -1).join('/').split("scenarios/")[1] + '/' + scenario.mapInfo.image);
                    return mapImageSrc;
                  })()
                }/>
                {
                  mapLocations.filter((l) => {
                    // console.log(l);
                    return l.states.includes(this.state.selectedState);
                  }).map(l => (
                          <div
                            style={{position: 'absolute', top: `calc(${l.top}% - 100vw / 36)`, left: `calc(${l.left}% - 100vw / 72)`}}
                            // onClick={() => this.props.selectLocation(l.curStateLocID)}
                          >
                            <div
                              onDrop={(e) => {
                                e.preventDefault(); console.log("Dropped", e)
                                if(this.state.draggedUser.location !== l.id) {
                                  if(this.state.isMultiSelect) {
                                    this.props.move(this.state.selectedUsers.map((user) => user.id), l.curStateLocID);
                                  } else {
                                    this.props.move([this.state.draggedUser.id], l.curStateLocID); 
                                  }
                                }
                                this.props.selectPreviewLocation(l.curStateLocID);
                                // this.props.selectLocation(l.curStateLocID);
                              }}
                              onDragEnter={(e) => {console.log("Drag Enter", e); this.setState({dragTarget: l})}}
                              onDragOver={(e) => e.preventDefault()}
                              onDragLeave={(e) => {console.log("Drag Leave", e); this.setState({dragTarget: null})}}
                              onClick={() => {console.log("Selected location", l); this.props.selectLocation(l.curStateLocID)}}
                              style={{float: 'left'}}
                            >
                              <img src={marker} style={{width: 'calc(100vw / 36)', height: 'calc(100vw / 36)'}} />
                              <span style={{color: '#ffc235', border: '1px solid #ffc235', borderRadius: 4, padding: 2, background: 'white', fontSize: '1.2em'}}>{l.name}</span>
                            </div>
                            <div className={classNames({})} style={{maxWidth: 210, display: 'flex', flexWrap: 'wrap', position: 'relative', width: '100%'}}>
                              {l.users.map(u => {
                                // console.log({isMultiSelect: this.state.isMultiSelect, selectedUserFind: this.state.selectedUsers.find((user) => user.id === u.id)})
                                return (
                                <div 
                                  className={classNames({
                                    // 'map_participant_preview': !this.state.isMultiSelect && this.state.selectedUsers.find((user) => user.id === u.id),
                                    // 'map_participant_no_preview': !(!this.state.isMultiSelect && this.state.selectedUsers.find((user) => user.id === u.id))
                                  })}
                                  title={u.name}
                                  draggable="true"
                                  style={{
                                    zIndex: 99,
                                    borderRadius: 5, padding: 2, margin: 2, maxWidth: 70, 
                                    // ...(this.state.selectedUsers.find((user) => user.id === u.id)? {background: '#ffc235'}: {background: 'white'}),
                                    ...(!this.state.isMultiSelect && {background: (this.props.selectedUnits.includes(u.id))? '#4dff35' : 'white'}),
                                    ...(this.state.isMultiSelect && {background: this.state.selectedUsers.find((user) => user.id === u.id)? '#f579fc' : 'white'}),
                                  }}
                                  onDragStart={(e) => {
                                    console.log("Drag Started", e);
                                    this.draggedElement.current = e.target;
                                    e.dataTransfer.setData("Text", u.id);
                                    this.setState({
                                      draggedUser: u,
                                      ...(this.state.isMultiSelect && !this.state.selectedUsers.find((user) => user.id === u.id) && {selectedUsers: this.state.selectedUsers.concat(u)})
                                    });
                                  }}
                                  onDrag={(e) => {
                                    e.preventDefault();
                                    this.draggedElement.current.style.display = 'none';
                                    // this.draggedElement.current.style.position = "absolute";
                                    // this.draggedElement.current.style.position = "relative";
                                    // this.draggedElement.current.style.top = e.clientY + "px";
                                    // this.draggedElement.current.style.left = e.clientX + "px";
                                  }}
                                  onDragEnd={(e) => {
                                    console.log("Drag End", e);
                                    this.setState({draggedUser: null});
                                    setTimeout(() => {
                                      this.draggedElement.current.style.display = 'unset';
                                    }, 200)
                                    // this.draggedElement.current.style.position = 'relative';
                                    // this.draggedElement.current.style.top = 'unset';
                                    // this.draggedElement.current.style.left = 'unset';
                                    // this.draggedElement.current = null;
                                  }}
                                  onClick={() => {
                                    // console.log("Multi select is", this.state.isMultiSelect);
                                    if(!this.state.isMultiSelect) {
                                      if(this.props.selectedUnits.includes(u.id)) {
                                        return this.props.selectUnits([]);
                                      }
                                      this.props.selectUnits([u.id]);
                                      return;
                                    };
                                    const userIndex = this.state.selectedUsers.findIndex((user) => user.id === u.id);
                                    console.log("On click", u, "userIndex", userIndex);
                                    if(userIndex === -1) {
                                      this.setState((prevState) => ({selectedUsers: prevState.selectedUsers.concat(u)})) 
                                    } else {
                                      this.setState((prevState) => ({selectedUsers: prevState.selectedUsers.filter((_, index) => index !== userIndex)}))
                                    }
                                    this.onUnitClick(undefined, u.id)
                                  }}
                                >
                                  <Tippy content={u.name} placement="bottom">
                                    <span style={{fontSize: '1vw'}}>{u.name.length > 9? (u.name.substring(0,6) + "..." ) : u.name}</span>
                                  </Tippy>
                                </div>
                                )
                              })}
                            </div>
                          </div>
                  )
                )}
              </div>
          </div>
          <div className="mapview__list">
            <div className="mapview__list_table">
              <div className="mapview__list_table_head">
                <div className="mapview__list_table_row">
                  <div className="mapview__list_table_cell">{I18n.t('exerciseRun.Participant')}</div>
                  <div className="mapview__list_table_cell">Show Map</div>
                  <div className="mapview__list_table_cell" style={{textAlign: 'right'}}>{I18n.t('exerciseRun.location')}</div>
                </div>
              </div>
              <div className="mapview__list_table_body">
                {participants.map(user => <div className={classNames({
                  "mapview__list_table_row": true,
                  "mapview__list_table_row--selected": this.props.selectedUnits.includes(user.id)
                })}>
                  <div 
                    className="mapview__list_table_cell"
                    style={{cursor: 'pointer'}}
                    onClick={(e) => {
                      this.onUnitClick(e, user.id)
                      const userIndex = this.state.selectedUsers.findIndex((selectedUser) => selectedUser.id === user.id);
                      console.log("On click", user, "userIndex", userIndex);
                      if(userIndex === -1) {
                        this.setState((prevState) => ({selectedUsers: prevState.selectedUsers.concat(user)})) 
                      } else {
                        this.setState((prevState) => ({selectedUsers: prevState.selectedUsers.filter((_, index) => index !== userIndex)}))
                      }
                    }}
                  >
                    {/* makeUniqueAbbreviation(user.name) */}{user.name}
                  </div>
                  <div className="mapview__list_table_cell">
                    <input type="checkbox" className="form-check-input" onChange={(e) => this.setShowMapToUser(e.target.checked, user.id)} />
                  </div>
                  <div className="mapview__list_table_cell" style={{textAlign: 'right'}}>
                    {/*<select value={locations_by_ids[user.location].id} onChange={(e) => this.props.move([user.id], e.target.value)}>*/}
                    <select value={locations_by_ids[user.location].id} onChange={(e) => this.props.move(this.state.isMultiSelect? this.props.selectedUnits : [user.id], e.target.value)}>
                      {
                        locations.filter((location) => location.state === this.props.exercise.state).map((location) => (
                          <option value={location.id}>{location.name}</option>
                        ))
                      }
                    </select>
                  </div>
                </div>)}
              </div>
            </div>
          </div>
        </div>}
        {
          !show_map &&
          <div className={'unidash' + ' unidash--' + this.state.unitsPerRow + '-per-row'}>
            <DragDropContext onDragStart={this.onDragStart.bind(this)}
                             onDragEnd={this.onDragEnd.bind(this)}>
              {
                (locations || []).map((location, i) => {
                    let isEmptyLoc = location.name.indexOf('__') === 0;
  
                    return <div
                      className={classNames({
                        'unidash__view': true,
                        'unidash__view--current-state': location.state === exercise.state,
                        'unidash__view--greyBack': !isEmptyLoc,
                        'unidash__view--selected': this.props.selectedLocation === location.id,
                        'unidash__view--gap': isEmptyLoc,
                      })}
                      key={i}>
  
                      <div className={'unidash__view-title'}
                           title={isEmptyLoc ? '' : location.name + (location.state ? ` [${location.state}]` : '')}
                           location_id={location.id}
                           onClick={(e) => !isEmptyLoc && this.props.selectLocation(location.curStateLocID)}>{isEmptyLoc ? '' : location.name + (location.state ? ` [${location.state}]` : '')}</div>
                      <div className={style['unidash__view-container']}>
  
                        {!isEmptyLoc ?
                          <Droppable droppableId={location.id}>
                            {(provided, snapshot) => (
  
                              <div ref={provided.innerRef}>
                                {location.users.map((user, i) => {
                                  let className = classNames({
                                    [style['unidash__unit']]: true,
                                    [style['unidash__unit--multi']]: this.props.selectedUnits.indexOf(user.id) >= 0,
                                    [style['unidash__unit--multi-dragging']]: this.props.selectedUnits.indexOf(user.id) !== -1 && this.state.isDragging && this.state.draggableId !== user.id
                                  });
                                  return (
                                    <Draggable key={user.id}
                                               draggableId={user.id} index={i}
                                    >
                                      {(provided, snapshot) => {
  
                                        const shouldShowSelection = snapshot.isDragging && this.props.selectedUnits.length > 1;
  
                                        return <div className={className}
                                                    title={user.name}
                                                    onClick={(e) => this.onUnitClick(e, user.id)}
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}>
  
                                          {user.name}
                                          {shouldShowSelection ? <div
                                            className="unidash__dragging-count">{this.props.selectedUnits.length}</div> : null}
  
                                        </div>;
  
  
                                      }}
  
                                    </Draggable>
                                  );
                                })
                                }
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                          :
                          <div></div>
                        }
                      </div>
                    </div>;
                  }
                )
              }
            </DragDropContext>
          </div>
        }
      </div>
    );
  }
}


Dashboard.propTypes = {
  exercise: PropTypes.object,
  move: PropTypes.func,
  stateChange: PropTypes.func,
  selectedUnits: PropTypes.array,
  selectedLocation: PropTypes.string,
};

const mapStateToProps = state => ({
  exercise: state.exercise.exercise,
  selectedUnits: state.dashboard.selectedUnits,
  selectedLocation: state.dashboard.selectedLocation,
});

const mapDispatchToProps = {
  move: moveAction,
  stateChange: stateChangeAction,
  selectUnits: selectUnitsAction,
  selectLocation: selectLocationAction,
  selectPreviewLocation: selectPreviewLocationAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Dashboard);

